import React, { type ReactNode, useEffect } from 'react'
import { useDocumentData } from 'react-firebase-hooks/firestore'

import { captureException } from '@sentry/react'

import {
  adminBreakersDocument,
  type ConfigurationAdminBreakersSnapshotData,
  DEFAULT_ADMIN_BREAKERS_VALUE,
} from '@/model/firestore/adminBreakersDocument.ts'

export type AdminBreakersContextValue = ConfigurationAdminBreakersSnapshotData

export const AdminBreakersContext = React.createContext<AdminBreakersContextValue>(DEFAULT_ADMIN_BREAKERS_VALUE)

export interface AdminBreakersProviderProps {
  children: ReactNode
}

export const AdminBreakersProvider: React.FC<AdminBreakersProviderProps> = ({ children }) => {
  const [configuration, loading, error] =
    useDocumentData<ConfigurationAdminBreakersSnapshotData>(adminBreakersDocument())
  useEffect(() => {
    if (error) {
      captureException(error, {
        tags: { 'firestore.document.snapshot': 'configurations' },
        fingerprint: ['firestore', 'document', 'configurations', 'AdminBreakers'],
        extra: { documentId: 'AdminBreakers' },
      })
    }
  }, [error])
  if (loading || !configuration) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }

  return <AdminBreakersContext.Provider value={configuration}>{children}</AdminBreakersContext.Provider>
}
